/* eslint-disable import/prefer-default-export */
export const PRODUCT_STATUS = {
  APPROVED: 'approved',
  REVIEWING: 'reviewing',
  REJECTED: 'rejected',
  NOT_FOUND: 'not_found',
  SYSTEM_PAUSED: 'system_paused',
}
